import { useMediaQuery, useTheme } from "@mui/material";
import { GenericTable } from "./GenericTable";
import { GenericTableMobileCards } from "./GenericTableMobileCards";
import { GenericTableProps } from "./types";

/**
 * Desktop: tabela. Mobile: carrossel de cards (sem paginação).
 */
export function ResponsiveGenericTable<T extends Record<string, unknown>>(
  props: GenericTableProps<T>
) {
  const theme = useTheme();
  const isMobileLayout = useMediaQuery(theme.breakpoints.down("md"));

  if (isMobileLayout) {
    return <GenericTableMobileCards {...props} />;
  }

  return <GenericTable {...props} />;
}
